import React, { Suspense } from 'react';
import { ProgressChartContainer } from 'shared/components/ui/progress-chart-container';
import { NumberFormat } from 'shared/types/number-format-options';

const TimeProgressChart = React.lazy(async () => ({
  default: (await import('shared/components/ui/time-progress-chart'))
    .TimeProgressChart,
}));

export type ProgressChartSectionProps = Omit<
  React.ComponentProps<typeof ProgressChartContainer>,
  'children'
> &
  Omit<React.ComponentProps<typeof TimeProgressChart>, 'endValue'> & {
    numberFormat?: NumberFormat;
  };

export const ProgressChartSection: React.FC<ProgressChartSectionProps> = ({
  target,
  lastEntryValue,
  targetFormat,
  onUpdateProgress,
  onShowHistory,
  onEditTarget,
  onEditStartDate,
  onEditDeadline,
  onComplete,
  isCompleted,
  isUneditable,
  data,
  startDate,
  endDate,
  startValue,
  completed,
  isComplete,
  weekStartsOn,
  numberFormat,
}) => (
  <ProgressChartContainer
    target={target}
    lastEntryValue={lastEntryValue}
    targetFormat={targetFormat}
    onUpdateProgress={onUpdateProgress}
    onShowHistory={onShowHistory}
    onEditTarget={onEditTarget}
    onEditStartDate={onEditStartDate}
    onEditDeadline={onEditDeadline}
    onComplete={onComplete}
    isCompleted={isCompleted}
    isUneditable={isUneditable}
  >
    <Suspense>
      <TimeProgressChart
        data={data}
        startDate={startDate}
        endDate={endDate}
        startValue={startValue}
        endValue={target}
        completed={completed}
        isComplete={isComplete}
        weekStartsOn={weekStartsOn}
        showTodayCount
        showTodayLine
        numberFormat={numberFormat}
      />
    </Suspense>
  </ProgressChartContainer>
);
